<div
  class="auto-complete-dropdown-container"
  [ngClass]="{ showing_suggestions: showSuggestions }"
>

  <div class="search-bar" [ngClass]="{ search_focused: focusSearch, 'has-pills': multiSelect && selectedItems.size > 0 }" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="focusInput()">
    <app-svg-icon class="image-icon" [path]="'assets/icons/search_icon.svg'" *ngIf="showIcon"></app-svg-icon>
    <div class="selected-pills" *ngIf="multiSelect && selectedItems.size > 0">
      <nz-tag
        *ngFor="let item of visiblePills"
      >
        {{ item.value ? CommonUtils.getNestedValue(item.value, bindLabel) : item.key }}
      </nz-tag>
      <span class="overflow-badge" *ngIf="hiddenPillsCount > 0">+{{ hiddenPillsCount }} Items</span>
    </div>
    <input
      #searchInput
      autocomplete="off"
      type="search"
      name="search"
      [id]="id"
      [readOnly]="readonly"
      [placeholder]="selectedItems.size > 0 ? '' : placeholder"
      [(ngModel)]="searchTerm"
      (ngModelChange)="updateSearchTerm()"
      (focus)="onInputFocus()"
      (focusout)="onInputFocusOut()"
      (keyup.escape)="showSuggestions = false"
      [disabled]="disable"
      [ngClass]="{'form_error': hasError(), 'show-icon': showIcon && selectedItems.size === 0}"
      (keydown)="onInputKeydown($event)"
      (paste)="onInputPaste($event)"
      (input)="handleInput()"
    />
  </div>
  <ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="showSuggestions"
    [cdkConnectedOverlayPanelClass]="'autocomplete-overlay-panel'"
    [cdkConnectedOverlayWidth]="triggerWidth"
    [cdkConnectedOverlayOffsetX]="overlayOffsetX"
    [cdkConnectedOverlayHasBackdrop]="true"
    (overlayOutsideClick)="showSuggestions = false"
    (attach)="onOverlayAttached()"
    [cdkConnectedOverlayPositions]="overlayPositions"
  >
    <div
      #resultsContainer
      class="search-results"
      [ngClass]="{ search_focused: focusSearch }"
      (scroll)="onScroll()"
      (wheel)="onWheel($event)"
    >
      <table class="suggestions-table">
        <thead *ngIf="displayColumns.length > 1 && suggestions.length > 0">
        <tr>
          @if (multiSelect) {
            <th></th>
          }
          <th *ngFor="let column of displayColumns">{{ column.header }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let result of suggestions; let i = index"
            (click)="select(result)"
            (keyup.enter)="select(result)"
            (mouseenter)="setActiveOption(i)"
            #optionRow
            [class.active]="i === activeOptionIndex">
          <td *ngIf="multiSelect" class="cb_td"><input type="checkbox" [checked]="result.selected"></td>
          <td *ngFor="let column of displayColumns">
             <span [innerHTML]="formatColumnValue(result, column)"></span>
          </td>
        </tr>
        <tr
          *ngIf="suggestions.length === 0 && allowCustomInput && searchTerm"
          (click)="selectCustomInput(); $event.stopPropagation()"
        >
          <td [attr.colspan]="displayColumns.length" class="custom-input-suggestion">
            Use "<strong>{{ searchTerm }}</strong>" as input
          </td>
        </tr>
        </tbody>
      </table>

      <div class="result loading_results" *ngIf="loading">
        <app-spinner-loader></app-spinner-loader>
      </div>

      <div class="result no_results" *ngIf="suggestions.length === 0 && !loading && !allowCustomInput">
          <app-no-data-found></app-no-data-found>
      </div>
    </div>
  </ng-template>

</div>
